import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Container,
  Typography,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Box,
  Alert,
} from "@mui/material";
import BusinessIcon from "@mui/icons-material/Business";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import WorkIcon from "@mui/icons-material/Work";
import axios from "axios"; // Directly import axios
import API_BASE_URL from '../../src/config'; 

const JobDetails = () => {
  const { id } = useParams(); // Get the job ID from the URL params
  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate(); // Initialize navigate

  useEffect(() => {
    // Fetch job details from the API based on the job ID
    const fetchJobDetails = async () => {
      try {
        setLoading(true); // Start loading
        const response = await axios.get(`${API_BASE_URL}/jobs/${id}`);
        setJob(response.data); // Set job data to state
      } catch (err) {
        console.error("Error fetching job details:", err);
        setError("Failed to load job details. Please try again later.");
      } finally {
        setLoading(false); // Stop loading once the data is fetched
      }
    };

    fetchJobDetails(); // Fetch the job details on component mount

  }, [id]); // Dependency array includes `id` to refetch if the job ID changes

  // Loading state
  if (loading) {
    return (
      <Container maxWidth="md" sx={{ textAlign: "center", mt: 5 }}>
        <CircularProgress />
      </Container>
    );
  }

  // Error state
  if (error) {
    return (
      <Container maxWidth="md" sx={{ mt: 5, textAlign: "center" }}>
        <Alert severity="error">{error}</Alert>
      </Container>
    );
  }

  // Job not found or unavailable
  if (!job) {
    return (
      <Container maxWidth="md" sx={{ mt: 5, textAlign: "center" }}>
        <Alert severity="error">Job Not Found</Alert>
      </Container>
    );
  }

  // Displaying the job details
  return (
    <Container maxWidth="md" sx={{ mt: 5 }}>
      <Card sx={{ p: 3, boxShadow: 3 }}>
        <CardContent>
          <Typography variant="h4" color="primary" fontWeight="bold">
            {job.title}
          </Typography>

          <Box display="flex" alignItems="center" mt={2}>
            <BusinessIcon color="action" sx={{ mr: 1 }} />
            <Typography variant="body1">
              <strong>{job.company}</strong>
            </Typography>
          </Box>

          <Box display="flex" alignItems="center" mt={1}>
            <LocationOnIcon color="action" sx={{ mr: 1 }} />
            <Typography variant="body1">
              <strong>{job.location}</strong>
            </Typography>
          </Box>

          <Box display="flex" alignItems="center" mt={1}>
            <WorkIcon color="action" sx={{ mr: 1 }} />
            <Typography variant="body1">{job.description}</Typography>
          </Box>

          {/* Apply Now Button */}
          <Button
            variant="contained"
            color="success"
            onClick={() => navigate("/applynowjob", {
              state: { jobTitle: job.title, jobId: job.id }
            })}
            sx={{ mt: 3, width: "100%" }}
          >
            Apply Now
          </Button>
          
          <Button
            variant="contained"
            color="secondary"
            onClick={() => navigate("/jobs")}
            sx={{ mt: 3, width: "100%" }}
          >
            Back to Jobs 
          </Button>
        </CardContent>
      </Card>
    </Container>
  );
};

export default JobDetails;
